import * as React from "react"
import "./productCarousel.scss"
import { useDebouncedCallback } from "use-debounce"

function calculateScrollRight(ref: HTMLDivElement) {
	return ref.scrollWidth - (ref.scrollLeft + ref.clientWidth)
}

function swap(a: any, b: any) {
	return [b, a]
}

const ProductCarousel: React.FC = ({ children }) => {
	const container = React.useRef<HTMLDivElement>(null!)
	const [nextButtonDisabled, setNextButtonDisabled] = React.useState(false)
	const [prevButtonDisabled, setPrevButtonDisabled] = React.useState(true)

	function onScroll() {
		let scrollRight = calculateScrollRight(container.current)
		let scrollLeft = container.current.scrollLeft

		if (scrollLeft === 0) {
			;[scrollLeft, scrollRight] = swap(scrollLeft, scrollRight)
		}
		setPrevButtonDisabled(scrollRight <= 10)
		setNextButtonDisabled(scrollLeft <= 10)
	}

	const [debouncedOnScroll] = useDebouncedCallback(onScroll, 50)

	function nextButton() {
		if (!container.current) return
		container.current.scrollBy(-container.current.offsetWidth * (3 / 4), 0)
	}

	function prevButton() {
		if (!container.current) return
		container.current.scrollBy(container.current.offsetWidth * (3 / 4), 0)
	}

	return (
		<>
			<div
				ref={container}
				className="carousel"
				onScroll={debouncedOnScroll}
			>
				{React.Children.map(children, (child) =>
					React.cloneElement(
						child as React.ReactElement<{ className: string }>,
						{
							className: "carousel__item py-1",
						}
					)
				)}
			</div>
			<button
				disabled={prevButtonDisabled}
				className="carousel__button carousel__button--prev"
				onClick={prevButton}
			/>
			<button
				disabled={nextButtonDisabled}
				className="carousel__button carousel__button--next"
				onClick={nextButton}
			/>
		</>
	)
}

export default ProductCarousel
